<template>
  <div class="password-reset py-32">
    <div class="mt-16 md:mt-0 px-7 flex items-center justify-center">
      <div v-loading="loading" class="bg-white p-12 w-full md-max-w-500 shadow-md rounded z-10">
        <h1 class="mb-6 o-heading-2 md:o-heading-1" v-text="success ? $t('LoginForm.EmailSent') : $t('LoginForm.PasswordReset')" />
        <form v-if="!success" @submit.prevent="reset">
          <OInput
            id="email"
            v-model="formData.email"
            :label="$t('LoginForm.EmailAddress')"
            type="text"
            name="email"
            :required="true"
            :error="emailErrorMessage"
            class="mb-3"
            :input-classes="['w-full']"
          />
          <div class="text-right pt-2">
            <OButton
              type="submit"
              variant="success"
            >
              {{ $t('LoginForm.SendEmail') }}
            </OButton>
          </div>
        </form>
        <div v-else>
          <p class="o-body" v-text="$t('LoginForm.EmailSentBody')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OButton from '@/components/OButton'
import OInput from '@/components/OInput'
import { REQUEST_PASSWORD_RESET } from '@/utils/store/actionTypes'
import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'PasswordReset',
  auth: 'guest',
  components: {
    OButton,
    OInput
  },
  layout: 'default',
  validations () {
    const validations = {
      formData: {
        email: {
          required,
          email
        }
      }
    }

    return validations
  },
  data () {
    return {
      formData: {
        email: ''
      },
      loading: false,
      success: false,
      invalidForm: false
    }
  },
  computed: {
    emailErrorMessage () {
      const fieldName = 'email'
      const item = this.$v.formData[fieldName]

      if (!item.$invalid || !this.invalidForm) {
        return ''
      }

      let errorMessage = this.$t('Error.invalid', { label: this.$t(`Form.Address.${fieldName}`) })

      const validations = {
        required: this.$t('Form.Error.Required'),
        email: this.$t('Form.Error.EmailIncorrect')
      }

      Object.keys(validations).forEach((rule) => {
        if (typeof item[rule] !== 'undefined' && !item[rule]) {
          errorMessage = validations[rule]
        }
      })

      return errorMessage
    }
  },
  methods: {
    async reset () {
      this.loading = true

      this.$v.$touch()

      if (this.$v.$invalid) {
        this.invalidForm = true
        this.loading = false

        return
      }

      try {
        await this[REQUEST_PASSWORD_RESET]({ email: this.formData.email })
      } catch (error) {
        this.$ota.general.logError(error)
      }

      this.loading = false
      this.success = true
    },
    ...mapActions('auth', [REQUEST_PASSWORD_RESET])
  }
}
</script>

<style lang="postcss" scoped>
  .password-reset {
    @apply relative w-full h-auto;
    background-image: url('~assets/img/baloo-men-camp_3x-min.webp');
    background-size: cover;
    background-position: center center;

    &:after {
      @apply absolute h-full w-full top-0 left-0 z-0;
      content: '';
      background: rgba(51,51,51, 0.1);
    }
  }

@screen md {
  .md-max-w-500 {
    max-width: 50rem;
  }
}
</style>
